export const setLoggedInUserNameSelector = state => state.setLoggedInUserName;

export const setToursSelector = state => state.setTours;
export const setTourFilterSelector = state => state.setTourFilter;

export const setTourInfoSelector = state => state.setTourInfo;
export const setTourNewSceneAndActiveSceneIndexSelector = state => state.setTourNewSceneAndActiveSceneIndex;
export const setTourActiveSceneIndexSelector = state => state.setTourActiveSceneIndex;
export const setActiveSceneSelector = state => state.setActiveScene;

export const  setHotspotActiveIndexSelector = state => state.setHotspotActiveIndex;

export const setShowHotspotModalSelector = state => state.setShowHotspotModal;

export const setTourSceneNewHotspotSelector = state => state.setTourSceneNewHotspot;
export const setTourSceneHotspotSelector = state => state.setTourSceneHotspot
export const removeHotspotFromSceneSelector = state => state.removeHotspotFromScene

export const removeTourSelector = state => state.removeTour;
export const setTourObjSelector = state => state.setTour;
export const updateTourByIdSelector = state => state.updateTourById;
export const resetTourSelector = state => state.resetTour;

export const removeSceneSelector = state => state.removeScene; 
export const setUserSelector = state => state.setUser;
export const resetUserSelector = state => state.resetUser;

export const setAlertMessageSelector = state => state.setAlertMessage;
export const setLoaderSelector = state => state.setLoader;

export const setConfirmModelSelector = state => state.setConfirmModel;

export const setTourErrorInfoSelector = state => state.setTourErrorInfo;

export const setTourNewSceneErrorSelector = state => state.setTourNewSceneError;

export const setActiveSceneErrorSelector = state => state.setActiveSceneError

export const setTourSceneNewHotspotErrorSelector = state => state.setTourSceneNewHotspotError;

export const setTourSceneHotspotErrorSelector = state => state.setTourSceneHotspotError;

export const setNotificationMessageSelector = state => state.setNotificationMessage;

export const resetTourErrorSelector = state => state.resetTourError;

export const setUsersSelector = state => state.setUsers;

export const setHotspotPauseAudioSelector = state => state.setHotspotPauseAudio;

export const setScenePauseAudioSelector = state => state.setScenePauseAudio;

export const setTourErrorActiveSceneIndexSelector = state => state.setTourErrorActiveSceneIndex;

export const setChangeHotspotPositionSelector = state => state.setChangeHotspotPosition;

export const setTourPrivacySelector = state => state.setTourPrivacy;
